import React, { Component, useContext, useState, useEffect, Fragment } from "react";
import Title from './Title';
import styled, {css
} from 'styled-components';
// import { storeProducts } from '../data';
import { ProductContext } from "../../context";
import Group from './Group.js';
import { throws } from 'assert';
import MenuMaterial from './MenuMaterial';
import Product from './Product';
import CartCard from './CartCard';



function Menu ({
  blockOrder = 0,
  filter,
  cardType,
  theme,
})  {


  console.log('cardType = ', cardType);




  const changeGroupHandler = (newActive) => {
    // valueFromContext.setStateFrom(
    //   'activeGroup', newActive
    // )
    let newSections = [...valueFromContext['sections']];
    newSections[blockOrder]['activeGroup'] = newActive;
    valueFromContext.setStateFrom(
      'sections', newSections
      // 'activeModule', newActive
    )
  }

  const changeGlobalHandler = (newActive) => {
    let newSections = [...valueFromContext['sections']];
    newSections[blockOrder]['activeModule'] = newActive;
    valueFromContext.setStateFrom(
      'sections', newSections
      // 'activeModule', newActive
    )
  }


  const valueFromContext = useContext(ProductContext);

  let count = 0;



  const getMenuGroups = (groups = [
    { id: 8593, name: 'All' },
    { id: 8740, name: 'Empire' },
    { id: 8778, name: 'Equipment' },
  ]) => {
    let newGroups = []
    groups.forEach((oneGroup, key) => newGroups.push({
          value: oneGroup['id'],
          label: oneGroup['name']
        })
    )
    return newGroups
  }



  if (valueFromContext && valueFromContext.psToken)
     {return (
      <div className="">
      <CssStore00
        theme={theme}
        cardType={cardType}
        style={{
          // backgroundColor: valueFromContext.theme['colorBg'],
          backgroundColor: 'transparent',
          color: valueFromContext.theme['colorText'],
        }}
        >





        {false && valueFromContext.virtualItems
          && valueFromContext.currency
          && valueFromContext.subscriptions
          &&
          <CssMenu>
          {/* <CssList0> */}

            <MenuMaterial
              theme={theme}
              blockOrder = {blockOrder}
              menuItems = {getMenuGroups(
                [{
                  id: 'virtualItems',
                  name: 'Virtual Items',
                },{
                  id: 'currency',
                  name: 'Currency',
                },{
                  id: 'subscriptions',
                  name: 'Subscriptions',
                }]
              )}
              // menuItems={
              //   [{
              //     id: 'virtualItems',
              //     name: 'Virtual Items',
              //   },{
              //     id: 'currency',
              //     name: 'Currency',
              //   },{
              //     id: 'subscriptions',
              //     name: 'Subscriptions',
              //   }]
              // }

              menuSource = 'activeModule'
              active={valueFromContext['sections'][blockOrder]['activeModule']}
              changeGlobalHandler={changeGlobalHandler}
              // changeGroupHandler={changeGroupHandler}
            />

          {/* </CssList0> */}
        </CssMenu>
      }




        {(valueFromContext['sections'][blockOrder]['activeModule'] === 'virtualItems')
          && valueFromContext.virtualItems
          && <CssProductList>
          {/* <CssList0> */}
            <CssMenu>
              <MenuMaterial
                theme={theme}
                blockOrder={blockOrder}
                key={`menu_${blockOrder}`}
                menuItems={getMenuGroups(valueFromContext.virtualItems)}
                // changeGlobalHandler={changeGlobalHandler}
                changeGroupHandler={changeGroupHandler}
                menuSource = 'activeGroup'
              />
            </CssMenu>
          {/* </CssList0> */}


          </CssProductList>
        }









    </CssStore00>


    </div>

  )} else {
    return null
  }


}


export const CssList0 = styled.div`
  position: relative;
  padding: 0 70px;
  width: 100%;
`


const CssStore00 = styled.div`
  position: relative;
  z-index: 4;
  color: ${({theme}) => theme ? theme['colorText'] : 'white'};
  ${({cardType, theme}) => cardType !== 'cart' && theme && css`
    /* margin: 0 ${({theme}) => theme ? parseInt(theme["cardWidth"], 0) / 6 : 40}px; */
    margin: 0 2em;
  `}
`
const CssProductList = styled.div`
  /* position: relative;
  z-index: 4; */
`


const CssMenu = styled.div`
  /* display: flex; */
  align-items: center;
  flex-grow: 1;
  /* margin: 24px 0; */
  overflow: auto;

  @media (max-width: 767px) {
    margin: 0px 0;
  }
`



const СssGroup = styled.div`

  ${({cardType, theme}) => cardType !== 'cart' && css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${({theme}) => theme ? theme["cardWidth"] : 200}px, 1fr));
    grid-auto-rows: ${({theme}) => theme ? parseInt(theme["cardWidth"], 0) + parseInt(theme["cardWidth"], 0)/2 : 240}px;
    grid-column-gap: ${({theme}) => parseInt(theme["cardWidth"], 0) / 8}px;
    grid-row-gap: ${({theme}) => parseInt(theme["cardWidth"], 0) / 6}px;
    /* grid-column-gap: ${({theme}) => theme["cardPadding"]}px; */
    /* grid-row-gap: ${({theme}) => theme["cardPadding"]}px; */
    /* grid-template-rows: repeat(auto-fill, minmax(${({theme}) => theme ? theme["cardWidth"] : 200}px, 1fr)); */
    /* grid-template-columns: repeat(auto-fill, ${({theme}) => theme ? theme["cardWidth"] : 200}px); */
  `}

  ${({cardType, theme}) => cardType === 'cart' && css`
    display: grid;
    grid-template-columns: 1fr;
    /* grid-auto-rows: ${({theme}) => theme ? parseInt(theme["cardWidth"], 0) + parseInt(theme["cardWidth"], 0)/2 : 240}px; */
    /* grid-column-gap: ${({theme}) => parseInt(theme["cardWidth"], 0) / 8}px; */
    grid-row-gap: 16px;
    /* grid-column-gap: ${({theme}) => theme["cardPadding"]}px; */
    /* grid-row-gap: ${({theme}) => theme["cardPadding"]}px; */
    /* grid-template-rows: repeat(auto-fill, minmax(${({theme}) => theme ? theme["cardWidth"] : 200}px, 1fr)); */
    /* grid-template-columns: repeat(auto-fill, ${({theme}) => theme ? theme["cardWidth"] : 200}px); */
  `}
`


const СssTitle = styled.div`
  color: ${({theme}) => theme['colorText']};
  padding-top: 2em;
  min-height: 2em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align:center;
  width: 100%;
  font-size: 1.6em;
  font-weight: bolder;
  /* text-transform: uppercase; */
  letter-spacing: 0.05em;
`


export default Menu;